module.exports = __webpack_public_path__ + "img/icon_facebook.873c35924184203d87a160d85cca1897.svg";